const AUDIENCES_TYPES = [
  {
    ico: require("@/assets/ico-checklist.svg"),
    key: "targeting",
    name: "Lidé, kteří mě neznají",
    tooltip: null,
    description:
      "se zaměřuje na nové zákazníky, kteří s vaším podnikáním ještě neinteragovali. Nastavením demografických údajů a okruhů zájmů definujete cílovou skupinu, ze které pak můžete získat zákazníky.",
    children: [
      {
        name: "Nové cílení",
        key: "new",
        ico: require("@/assets/ico-add-alt.svg"),
      },
      {
        name: "Uložené cílení",
        key: "saved",
        ico: require("@/assets/ico-list.svg"),
      },
    ],
  },
  {
    ico: require("@/assets/ico-book-user.svg"),
    key: "audience",
    name: "Návštěvníci, sledující, klienti",
    tooltip: null,
    description:
      "je sekce, kde můžete pracovat s uživateli, kteří s vaším podnikáním nějakým způsobem interagovali. Např. přišli na webovou stránku.",
    children: [
      {
        name: "Nové publikum ze šablony",
        key: "template",
        ico: require("@/assets/ico-template.svg"),
      },
      {
        name: "Nové podobné publikum",
        key: "lookalike",
        ico: require("@/assets/ico-template-alt.svg"),
      },
      {
        name: "Uložené publikum",
        key: "saved",
        ico: require("@/assets/ico-list.svg"),
      },
      {
        name: "Nové složené publikum",
        key: "setOf",
        ico: require("@/assets/ico-add-alt.svg"),
      },
    ],
  },
]

export { AUDIENCES_TYPES }
